/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArenaScoringEvent } from './ArenaScoringEvent';
import {
    ArenaScoringEventFromJSON,
    ArenaScoringEventFromJSONTyped,
    ArenaScoringEventToJSON,
    ArenaScoringEventToJSONTyped,
} from './ArenaScoringEvent';
import type { MetricType } from './MetricType';
import {
    MetricTypeFromJSON,
    MetricTypeFromJSONTyped,
    MetricTypeToJSON,
    MetricTypeToJSONTyped,
} from './MetricType';

/**
 * Configuration for Time Challenge (SCORE_ACCUMULATION) strategy
 * @export
 * @interface TimeAttackConfig
 */
export interface TimeAttackConfig {
    /**
     * Allowed duration options in minutes
     * @type {Array<number>}
     * @memberof TimeAttackConfig
     */
    allowedDurations?: Array<number>;
    /**
     * Default duration in minutes
     * @type {number}
     * @memberof TimeAttackConfig
     */
    defaultDuration?: number;
    /**
     * Events that contribute points during time window
     * @type {Array<ArenaScoringEvent>}
     * @memberof TimeAttackConfig
     */
    scoringEvents?: Array<ArenaScoringEvent>;
    /**
     * (Deprecated) Use scoringEvents instead
     * @type {Array<MetricType>}
     * @memberof TimeAttackConfig
     */
    allowedMetrics?: Array<MetricType>;
    /**
     * 
     * @type {MetricType}
     * @memberof TimeAttackConfig
     */
    defaultMetric?: MetricType;
}



/**
 * Check if a given object implements the TimeAttackConfig interface.
 */
export function instanceOfTimeAttackConfig(value: object): value is TimeAttackConfig {
    return true;
}

export function TimeAttackConfigFromJSON(json: any): TimeAttackConfig {
    return TimeAttackConfigFromJSONTyped(json, false);
}

export function TimeAttackConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeAttackConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'allowedDurations': json['allowedDurations'] == null ? undefined : json['allowedDurations'],
        'defaultDuration': json['defaultDuration'] == null ? undefined : json['defaultDuration'],
        'scoringEvents': json['scoringEvents'] == null ? undefined : ((json['scoringEvents'] as Array<any>).map(ArenaScoringEventFromJSON)),
        'allowedMetrics': json['allowedMetrics'] == null ? undefined : ((json['allowedMetrics'] as Array<any>).map(MetricTypeFromJSON)),
        'defaultMetric': json['defaultMetric'] == null ? undefined : MetricTypeFromJSON(json['defaultMetric']),
    };
}

export function TimeAttackConfigToJSON(json: any): TimeAttackConfig {
    return TimeAttackConfigToJSONTyped(json, false);
}

export function TimeAttackConfigToJSONTyped(value?: TimeAttackConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowedDurations': value['allowedDurations'],
        'defaultDuration': value['defaultDuration'],
        'scoringEvents': value['scoringEvents'] == null ? undefined : ((value['scoringEvents'] as Array<any>).map(ArenaScoringEventToJSON)),
        'allowedMetrics': value['allowedMetrics'] == null ? undefined : ((value['allowedMetrics'] as Array<any>).map(MetricTypeToJSON)),
        'defaultMetric': MetricTypeToJSON(value['defaultMetric']),
    };
}

